import main from './main'
export default {
  main
}



// WEBPACK FOOTER //
// ./src/app/configuration/FordLegacy/config/index.js